import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Popover from './popover'
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import FavoriteIcon from '@material-ui/icons/Favorite';
import NavigationIcon from '@material-ui/icons/Navigation';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'fixed', 
    bottom: theme.spacing(5),
    right: theme.spacing(5),
    zIndex: 1000,
    border: '8px solid #b499d7',
    '&:focus': {
        border: '8px solid #b499d7',
    },
  },
  fabText: {
    position: 'fixed', 
    bottom: theme.spacing(5),
    right: theme.spacing(5),
    backgroundColor: '#b499d7',
    height: '56px',
    zIndex: 1000,
    borderRadius: '28px', 
    padding: '10px',
    paddingRight: '56px',
    fontFamily: 'Montserrat', 
    color: 'white', 
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  span: {
    backgroundColor: '#b499d7',
    borderRadius: '50%', 
  }
}));

export default function FloatingActionButtons(props) {
  const classes = useStyles();
    const [text, setText] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const ref = useRef(null)

  return (<>
  <Popover anchorEl={anchorEl} setAnchorEl={setAnchorEl} {...props} />
    {text && <div onClick={(e) => setAnchorEl(ref.current)} onMouseEnter={() => setText(true)} onMouseLeave={() => setText(false)} className={classes.fabText} >
        Help And Accessibility
    </div>}
      <Fab className={classes.fab} ref={ref} onClick={(e) => setAnchorEl(e.currentTarget)} onMouseEnter={() => setText(true)} onMouseLeave={() => setText(false)} classes={{label: classes.span}} aria-label="add">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" data-agastya-ignore=""><path fill="#ffffff" d="M49.86 0a49.86 49.86 0 1 0 0 99.72 49.86 49.86 0 0 0 0-99.72zm-.75 9.9a6.46 6.46 0 1 1 .01 12.91 6.46 6.46 0 0 1-.01-12.9zm27.94 20.83l-19.18 2.42v19.2l9.3 31.03a3.62 3.62 0 0 1-2.63 4.4 3.57 3.57 0 0 1-4.4-2.54L50.62 57h-2.94l-8.76 28.83a3.6 3.6 0 0 1-4.7 2.01c-1.86-.73-3-2.84-2.27-4.72L40 52.67V33.15l-17.67-2.4a3.2 3.2 0 0 1-2.9-3.56 3.34 3.34 0 0 1 3.6-3.04L44.5 26h9.41l22.87-1.89a3.28 3.28 0 0 1 3.42 3.18 3.3 3.3 0 0 1-3.15 3.44z" data-agastya-ignore=""></path></svg>
      </Fab>
      </>
  );
}
